import { useLang } from "../App";
import Reveal, { Overline } from "./Reveal";

export default function Approach() {
  const { t } = useLang();
  return (
    <section id="approche" data-testid="approach-section" className="bg-ivory px-6 py-28 md:px-12 md:py-40 lg:px-20">
      <Reveal>
        <Overline>{t.approach.label}</Overline>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-10 font-serif text-4xl font-medium text-ink sm:text-5xl lg:text-6xl">
          {t.approach.headline}
        </h2>
      </Reveal>
      <div className="mt-20 grid gap-x-14 gap-y-14 sm:grid-cols-2 lg:grid-cols-4">
        {t.approach.items.map((item, i) => (
          <Reveal key={item.num} delay={i * 0.08}>
            <div data-testid={`approach-item-${i + 1}`} className="border-t border-bronze/40 pt-7">
              <span className="font-serif text-sm italic text-bronze">{item.num}</span>
              <h3 className="mt-4 text-[13px] font-semibold uppercase tracking-[0.28em] text-ink">
                {item.title}
              </h3>
              <p className="mt-4 text-sm font-light leading-relaxed text-ink/60">{item.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
